import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { errorDispatch } from "../../../functions/errorDispatch";
import { setDocTitle } from "../../../functions/HelperFuncs";

export default {
  data() {
    return {
      id: this.$options.name,
    };
  },
  created() {
    setDocTitle("account", this);

    EventBus.$on(`${this.id}-logout`, this.logout);
    EventBus.$on(`${this.id}-update`, this.updateAccount);
  },
  methods: {
    updateAccount() {
      const formData = new FormData(this.$refs.accountForm);

      this.$axios
        .post(`${baseUrl}/userupdate`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((r) => {
          const data = r.data;
          if (data.success) {
            this.$store.state.user = data;
            this.$axios.defaults.params["email"] = data.email;
            this.$axios.defaults.params["key"] = data.key;
            localStorage.setItem(
              this.$store.state.company + "_" + "user",
              JSON.stringify(data)
            );
          }
        })
        .catch((e) => {
          errorDispatch("account_update");
        });
    },
    logout() {
      this.$store.state.user = null;
      this.$axios.defaults.params["key"] = null;

      localStorage.setItem(
        this.$store.state.company + "_" + "user",
        JSON.stringify(null)
      );
      localStorage.setItem(
        this.$store.state.company + "_" + "folder_spaces",
        JSON.stringify(null)
      );
      localStorage.setItem(
        this.$store.state.company + "_" + "folder_myspace",
        JSON.stringify(null)
      );
      this.$router.push("/" + this.$store.state.company);
    },
    inputDefault(key) {
      const value = this.$store.state.user[key];
      return value !== "null" ? value : "";
    },
  },
};
